import { Chess } from "@chesshotel/chess";
/** These short lessons teach a concept with one decision per position. */
export function learningExerciseReply(exercise, action, move) {
    const board = new Chess(exercise.fen);
    const play = (uci) => board.move({
        from: uci.slice(0, 2),
        to: uci.slice(2, 4),
        promotion: uci[4],
    });
    if (exercise.choices) {
        if (action === "hint")
            return { fen: exercise.fen };
        if (action === "reveal")
            return { fen: exercise.fen, failed: true, answer: exercise.answer };
        if (action !== "answer" ||
            !exercise.choices.some((choice) => choice.id === move))
            throw new Error("Invalid lesson answer");
        return move === exercise.answer
            ? { fen: exercise.fen, correct: true, done: true }
            : { fen: exercise.fen, correct: false };
    }
    if (action === "hint")
        return { fen: exercise.fen, highlight: exercise.moves[0].slice(0, 2) };
    if (action === "reveal")
        return {
            fen: exercise.fen,
            failed: true,
            solution: play(exercise.moves[0]).san,
        };
    if (action !== "move" ||
        typeof move !== "string" ||
        !/^[a-h][1-8][a-h][1-8][qrbn]?$/.test(move))
        throw new Error("Invalid lesson action");
    if (!exercise.moves.includes(move))
        return { fen: exercise.fen, correct: false };
    play(move);
    return { fen: board.fen(), correct: true, done: true };
}
//# sourceMappingURL=learningExercise.js.map